var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"px-6 py-2",attrs:{"disabled":_vm.loading},on:{"click":_vm.clicked}},[(_vm.loading)?_c('spinner'):_c('span',[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }